export function htmlEncode(stringToEncode) {
    return { __html: stringToEncode };
}